import { createContext, useContext } from 'react';

/**
 * Context for sharing auth modal actions from AssistantLayout down to chat components.
 * This allows ChatUI to open auth modals (e.g., from Blueprint auth prompt buttons)
 * without prop drilling through the component tree.
 */
const AuthActionContext = createContext(null);

/**
 * Hook to access auth action functions (openCreateAccount, openLogin)
 * Returns null if not within an AuthActionProvider
 * @returns {{ openCreateAccount: Function, openLogin: Function } | null}
 */
export function useAuthAction() {
  return useContext(AuthActionContext);
}

export default AuthActionContext;
